// =============================================================
// cn — className utility (mimari plan)
// =============================================================

export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(" ");
}